import { initContract } from "@ts-rest/core";
import { z } from "zod";

import {
  auditTrailAuthEventSchema,
  auditTrailDownloadEventRecordTypeSchema,
} from "@libs/db-schemas";

import { HTTPStatusCode } from "../../types";

const c = initContract();

export const auditTrailsContract = c.router({
  recordAuthEvent: {
    summary: "Record an authentication event to the audit trails",
    method: "POST",
    path: "/audit-trails/auth",
    body: z.object({
      type: auditTrailAuthEventSchema,
    }),
    responses: {
      [HTTPStatusCode.CREATED]: c.noBody(),
    },
  },
  recordDownloadEvent: {
    summary: "Record a download event to the audit trails",
    method: "POST",
    path: "/audit-trails/download",
    body: z.object({
      type: auditTrailDownloadEventRecordTypeSchema,
      id: z.string(),
    }),
    responses: {
      [HTTPStatusCode.CREATED]: c.noBody(),
    },
  },
});
